<template>
  <div class="mainContent">
    <img class="logo" src="../assets/logo.png">
    <a href="http://atmedia.cc" style="margin-bottom: 25px;font-size: 2rem;">&gt;联系我们&lt;</a>
    <a href="https://herobabyorigin.campaignsites.cn" style="font-size: 2rem;">&gt;微信平台第三方自定义功能&lt;</a>
<!--    <a href="https://finnairmanager.diudiu001.com/" style="font-size: 2rem;">&gt;微信客服工作监督工具&lt;</a>-->
  </div>
</template>

<script>
export default {
  name: 'Index'
}
</script>

<style scoped>
.mainContent{
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex; /* Safari */
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logo{
  width: 730px;
  margin-bottom: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue